import { defineStore } from 'pinia'
import DeliveryService from "@/services/delivery.service";
import {AppConstant} from "@/supports/app.constant";

export const useDeliveryStore = defineStore('delivery', {
    state: () => {
        return {
            deliveries: [],
            delivery: [],
            deliveryDetail: [],
            totalPrice: 0,
            masterDeliveries: [],
            masterDeliveryDetail: {},
            delivery_export: [],
            paginate: {},
        }
    },
    persist: true,
    actions: {
        async getListDeliveries(url, params) {
            try {
                const res = await DeliveryService.getListDeliveries(url, params)
                this.deliveries = res.data.data
                this.paginate = res.data.meta
            } catch (e) {
                return null
            }
        },
        async getListDeliveriesWithoutLimit(url, params) {
            try {
                const res = await DeliveryService.getListDeliveries(url, params)
                this.deliveries = res.data.data
            } catch (e) {
                return null
            }
        },
        async getListMasterDeliveries(url, params) {
            try {
                const res = await DeliveryService.getListDeliveries(url, params)
                this.masterDeliveries = res.data.data
                this.paginate = res.data.meta
            } catch (e) {
                return null
            }
        },
        async createDeliveries(url, params) {
            try {
                const res = await DeliveryService.createDelivery(url, params)
                return res.data;
            } catch (e) {
                return e
            }
        },
        async getListMasterDelivery(url, params, flag_export = AppConstant.EXPORT_BILL_FALSE) {
            try {
                const res = await DeliveryService.getListMasterDelivery(url, params)
                if (flag_export === AppConstant.EXPORT_BILL_TRUE) {
                    this.delivery_export = res.data
                } else {
                    this.masterDeliveries = res.data
                }
            } catch (e) {
                return null
            }
        },
        async approveUserDelivery(url, params) {
            try {
                const res = await DeliveryService.approveUserDelivery(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },

        async rejectDelivery(url, params) {
            try {
                const res = await DeliveryService.rejectDelivery(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },
        async getMasterDeliveryDetail(url, params) {
            try {
                const res = await DeliveryService.getMasterDeliveryDetail(url, params)
                this.masterDeliveryDetail = res.data;
            } catch (e) {
                return e
            }
        },
        async getDeliveryDetail(url, params) {
            try {
                const res = await DeliveryService.getDeliveryDetail(url, params)
                this.delivery = res.data;
            } catch (e) {
                return e
            }
        },
        async getProductsDelivery(url, params) {
            try {
                const res = await DeliveryService.getProductsDelivery(url, params)
                this.deliveryDetail = res.data.products;
                this.totalPrice = res.data.total_price;
            } catch (e) {
                return e
            }
        },
    }
})
